import React from 'react';

export function RealExamples() {
  return (
    <div className="bg-gray-50 py-16">
      <div className="mx-auto max-w-4xl px-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-8">实陆使用场景</h2>
        
        <div className="space-y-8">
          <div className="bg-white rounded-lg p-6 shadow-sm">
            <h3 className="font-semibold text-gray-900 mb-2">场景一：学习笔记管理</h3>
            <p className="text-gray-600">
              大学生小李用 MemPalace 整理编程学习笔记。每次学完一个概念，
              就创建一个记忆单元，用双向链接把相关概念连接起来。
              三个月后，他的知识图谱已经包含了 200 多个节点。
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm">
            <h3 className="font-semibold text-gray-900 mb-2">场景二：项目知识库</h3>
            <p className="text-gray-600">
              开发团队用 MemPalace 建立项目知识库。每次会议纪要、
              技术决策、遇到的问题都记录下来，形成可追溯的知识资产。
              新成员入职时，通过知识图谱快速了解项目背景。
            </p>
          </div>

          <div className="bg-white rounded-lg p-6 shadow-sm">
            <h3 className="font-semibold text-gray-900 mb-2">场景三：个人灵感收集</h3>
            <p className="text-gray-600">
              设计师小王用 MemPalace 收集设计灵感。看到好的设计就截图保存，
              加上自己的想法和评价。半年后，这些零散的灵感形成了
              独特的设计风格参考库。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
